/** Una sola entrada de menú. Las rutas de bandeja siguen siendo el permiso. */
export const RUTA_ECHEQUE = "echeq";

export const VISTA_ECHEQUE = {
  CHEQUES: "cheques",
  RECHAZOS: "rechazos",
};

/** Rutas de system_menu que autorizan una pestaña y no se pintan en el árbol. */
export const RUTAS_MENU_ECHEQUE_OCULTAS = [
  "cheques_proveedores",
  "cheques_cc",
  "cheques_finanzas",
  "cheques_rechazos_finanzas",
  "cheques_rechazos_pagos",
  "cheques_rechazos_jefe",
  "cheques_rechazos_cc",
];

const RUTAS_OCULTAS = new Set(RUTAS_MENU_ECHEQUE_OCULTAS);

export const normalizarRutaMenuEcheq = (ruta) =>
  String(ruta || "")
    .trim()
    .replace(/^\/+/, "")
    .toLowerCase();

export const esRutaBandejaOcultaEcheq = (ruta) =>
  RUTAS_OCULTAS.has(normalizarRutaMenuEcheq(ruta));

export const leerParam = (search, key) => {
  const raw = String(search || "").replace(/^\?/, "");
  return new URLSearchParams(raw).get(key) || "";
};

export const rutaEcheq = ({ vista, bandeja } = {}) => {
  const params = new URLSearchParams();
  if (vista) params.set("vista", vista);
  if (bandeja) params.set("bandeja", bandeja);
  const qs = params.toString();
  return `/${RUTA_ECHEQUE}${qs ? `?${qs}` : ""}`;
};

/**
 * Si las bandejas cuelgan de eCheq, el padre queda como única entrada.
 * Si vinieran sueltas, se agrega una entrada eCheq para no dejarlas huérfanas.
 */
export const colapsarMenuEcheq = (data) => {
  if (!Array.isArray(data) || !data.length) return data;
  const ocultas = data.filter((item) => esRutaBandejaOcultaEcheq(item?.ruta));
  if (!ocultas.length) return data;

  const ids = new Set(data.map((item) => item.id_menu));
  const padresPresentes = ocultas.some(
    (item) => item.menu_padre_id != null && ids.has(item.menu_padre_id)
  );
  if (padresPresentes) return data;

  const muestra = ocultas[0];
  return [
    ...data,
    {
      id_menu: "echeq-entrada",
      menu: "eCheq",
      ruta: RUTA_ECHEQUE,
      menu_padre_id: null,
      icon: muestra.icon || "account_balance",
      font_family: muestra.font_family,
      background_color: muestra.background_color,
    },
  ];
};
